import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import queryString from 'query-string';

import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import AuthButton from 'components/base/AuthButton';
import BaseTabListContainer from 'containers/base/BaseTabListContainer';
import BaseListContainer from 'containers/base/BaseListContainer';
import { PermissionCodes } from 'config/PermissionCodes';
import { NavBarNames } from 'config/NavBarNameList';
import LevelFilter from './LevelFilter';
import ListButtonsGroup from 'components/base/ListButtonsGroup';
import AuthButtonWithDropdown from 'components/base/AuthButtonWithDropdown';
import LevelRulesModal from './LevelRulesModal';
import RetainMembershipTipsModal from './RetainMembershipTipsModal';
import LevelGlobalSettingModal from './LevelGlobalSettingModal';
import './LevelList.scss';

function LevelList({
  totalCount,
  pageInfo,
  totalPage,
  displayFields,
  pagedList,
  checkedList,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const [showLevelRules, setShowLevelRules] = useState(false);
  // const [showRetainMembership, setShowRetainMembership] = useState(false);
  const [showLevelGlobalSetting, setShowLevelGlobalSetting] = useState(false);

  const tabs = [
    {
      name: 'List',
      content: (
        <BaseTabListContainer
          hideTab={true}
          groupActions={[]}
          pageInfo={pageInfo}
          totalCount={totalCount || 0}
          filter={{
            hasFilter: true,
            component: LevelFilter,
          }}
          listContent={
            <BaseListContainer
              fields={displayFields}
              model={'levels'}
              permissionGroup={PermissionCodes.level}
              dataList={pagedList}
              totalPage={totalPage}
              deleteInfo={{
                data: [],
                title: NavBarNames.levels,
                relatedName: '',
                onComfirm: {},
                relatedSections: [],
              }}
              actions={[
                'Edit',
                'Detail',
              ]}
              hasOtherActions={true}
              customActions={{
                custom: (item) => ({
                  name: item.active ? 'Deactive' : 'Active',
                  action: (value) => {
                    dispatch({
                      type: `levels/updateLevelStatus`,
                      payload: {
                        pk: value?.pk,
                        levelName: value?.levelName,
                        active: !value?.active,
                        afterAction: () => history.push(location)
                      }
                    })
                  },
                  requires: [
                    PermissionCodes.changeLevel,
                  ],
                  isOnlyNeedOnePermission: true
                })
              }}
            />
          }
        />
      ),
    },
  ];

  const getLevelList = () => {
    const searchDict = queryString.parse(location.search);
    const searchKey = searchDict['search'];
    const order = searchDict['order'];
    const stringPage = searchDict['page'] || 1;
    const page = parseInt(stringPage);
    console.log(searchKey);
    dispatch({
      type: 'levels/getList',
      payload: {
        ...searchDict,
        filterName: searchKey,
        order,
        page,
        isListApi: true,
      },
    });
  };

  useEffect(() => {
    getLevelList();
  }, [location]);

  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={500}
      extraButtons={[
        <AuthButtonWithDropdown
          className='btn-download'
          customDropdownClassName="level-list-edit-content-dropdown"
          permissionRequires={PermissionCodes.changeLevel}
          title={'Edit Loyalty Program Content'}
          options={[
            {
              title: "Level Rules",
              action: () => {
                setShowLevelRules(true);
              }
            },
            // {
            //   title: "Retain Membership",
            //   action: () => {
            //     setShowRetainMembership(true);
            //   }
            // },
          ]}
        />,
        <AuthButton
          customClass="btn-back-button-common btn-download"
          title="Edit Level Global Setting"
          action={() => {
            setShowLevelGlobalSetting(true);
          }}
          requires={PermissionCodes.changeLevelsSettings}
        />,
        <AuthButton
          customClass="btn-further"
          title="Create Level"
          action={() => {
            history.push("/levels/create")
          }}
          requires={PermissionCodes.changeLevel}
        />,
      ]}
      extraPopContent={[
        {
          requires: PermissionCodes.changeLevel,
          action: () => {
            setShowLevelRules(true);
          },
          content: 'Level Rules',
        },
        // {
        //   requires: PermissionCodes.changeLevel,
        //   action: () => {
        //     setShowRetainMembership(true);
        //   },
        //   content: 'Retain Membership',
        // },
        {
          requires: PermissionCodes.changeLevelsSettings,
          action: () => {
            setShowLevelGlobalSetting(true);
          },
          content: 'Edit Level Global Setting',
        },
        {
          requires: PermissionCodes.changeLevel,
          action: () => {
            history.push("/levels/create")
          },
          content: 'Create Level',
        },
      ]}
    />,
  ];

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: NavBarNames.levels,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={true}
      />

      <LevelRulesModal
        show={showLevelRules}
        setShow={setShowLevelRules}
      />
      {/* <RetainMembershipTipsModal
        show={showRetainMembership}
        setShow={setShowRetainMembership}
      /> */}
      <LevelGlobalSettingModal
        show={showLevelGlobalSetting}
        setShow={setShowLevelGlobalSetting}
        successAction={getLevelList}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  totalCount: state.levels?.totalCount,
  pageInfo: state.levels?.pageInfo,
  totalPage: state.levels?.totalPage,
  displayFields: state.levels?.listDisplayFields,
  pagedList: state.levels?.pagedList,
  checkedList: state.levels?.checkedList,
})

export default connect(mapPropsToState)(LevelList)
